import { __decorate } from "tslib";
import { AuthService } from './auth.service';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { Injectable } from '@angular/core';
let KycReassessmentGuard = class KycReassessmentGuard {
    constructor(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    check() {
        if (this.authService.isAuthenticated()) {
            const user = JSON.parse(localStorage.getItem('user'));
            if (user === null || user === void 0 ? void 0 : user.kyc_reassessment_tx_blocked) {
                return this.router.parseUrl('/kyc-reassessment');
            }
        }
        return true;
    }
    canActivate() { return this.check(); }
    canActivateChild() { return this.check(); }
};
KycReassessmentGuard.ctorParameters = () => [
    { type: AuthService },
    { type: Router }
];
KycReassessmentGuard = __decorate([
    Injectable({ providedIn: 'root' })
], KycReassessmentGuard);
export { KycReassessmentGuard };
